import React from "react";

export function ValidationMessage(props) {
    const {invalid} = props;
    const key = props.schema && `error-message-${props.schema.key}`;
    return (invalid && <label data-test={key} className="error">{props.message}</label>) || ""
}
